<template>
  <article
    class="
      teaser-placeholder
      teaser-placeholder--lg-width-33
      teaser-placeholder--sm-width-50
    "
    aria-hidden="true"
  >
    <div class="teaser-placeholder__picture-wrapper">
      <div class="teaser-placeholder__picture">
        <div class="picture"></div>
      </div>
    </div>
    <div class="teaser-placeholder__content">
      <header class="teaser-placeholder__header">
        <span class="teaser-placeholder__heading"
          ><!-- html validation//--></span
        >
      </header>
      <p class="teaser-placeholder__description">
        <span v-if="!reducedTeaser" class="teaser-placeholder__line"
          ><!-- html validation//--></span
        >
        <span v-if="!reducedTeaser" class="teaser-placeholder__line"
          ><!-- html validation//--></span
        >
        <span v-if="!reducedTeaser" class="teaser-placeholder__line"
          ><!-- html validation//--></span
        >
        <span class="teaser-placeholder__line"><!-- html validation//--></span>
      </p>
    </div>
  </article>
</template>

<script>
export default {
  inject: {
    reducedTeaser: {
      default() {
        return {};
        // fail silently
      },
    },
  },
};
</script>
